/**
 * ResponsiveLayout — Picks the right layout based on auth state.
 *
 * Used for public-browsable routes (/rodeos, /jackpots, /events/:id) that
 * should render with the full app chrome (sidebar, breadcrumbs, user menu)
 * for signed-in users, but with a lighter header-only layout for visitors.
 *
 * Both layouts render <Outlet />, so child routes don't care which one wraps
 * them.
 */

import { useIsAuthenticated } from '../../state_management_and_stores/auth.store';
import { AppLayout } from './AppLayout';
import { PublicAppLayout } from './PublicAppLayout';

export function ResponsiveLayout() {
  const isAuthenticated = useIsAuthenticated();
  return isAuthenticated ? <AppLayout /> : <PublicAppLayout />;
}
